<!--<link href="/css/secure-layout.css" rel="stylesheet" type="text/css" media="all" />
<link href="/css/secure-style.css" rel="stylesheet" type="text/css" media="all" />-->

<div class="bg-wrap">
  <div id="loadingOverlay" class="mb-loading-hide">
    <div class="md-loadingRect">
      <div class="md-loadingRectChild md-loadingRect1"></div>
      <div class="md-loadingRectChild md-loadingRect2"></div>
      <div class="md-loadingRectChild md-loadingRect3"></div>
      <div class="md-loadingRectChild md-loadingRect4"></div>
      <div class="md-loadingRectChild md-loadingRect5"></div>
      <div class="md-loading-text">Loading...</div>
    </div>
    <div class="md-loading-mask"></div>
  </div>

  <modal-layout></modal-layout>

  <nav class="navbar">
    <div class="container">
      <div class="col-lg-3 col-md-3 col-sm-3 col-xs-5">
        <div class="logowrap"><a href=""><img src="/images/logo-main.png" /></a></div>
      </div>

      <div class="col-lg-9 col-md-9 col-sm-9 col-xs-7 no-padding-mobile">
        <div class="header-menu">
          <ul>
            <li class="account-menu-icon"><a class="logout-btn" (click)="logout()"><span>LOG OUT</span></a></li>
          </ul>
        </div>
      </div>
    </div>
  </nav>

  <div class="body-outer">
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  </div>

  <footer-layout></footer-layout>
</div>
